/**
 * La mappa si aggiorna da sola: mostra chi lavora ADESSO, e il battito delle sessioni arriva ogni 60 secondi. Si
 * aggiorna solo mentre la pagina è davanti agli occhi (una scheda nascosta non costa letture) e, quando si torna sulla
 * pagina, subito. In silenzio: niente rotelle, i dati vecchi restano finché arrivano quelli nuovi.
 */
import { useEffect, useRef } from 'react';

export const AGGIORNA_OGNI_MS = 60_000;

export function useAggiornamentoPeriodico(aggiorna: () => Promise<void>, attivo: boolean, ogniMs: number = AGGIORNA_OGNI_MS): void {
  const ultima = useRef(aggiorna);
  ultima.current = aggiorna;

  useEffect(() => {
    if (!attivo) return;
    let tempo: number | null = null;
    let inCorso = false;
    const esegui = async () => {
      if (inCorso || document.visibilityState !== 'visible') return;
      inCorso = true;
      try {
        await ultima.current();
      } finally {
        inCorso = false;
      }
    };
    const pianifica = () => {
      tempo = window.setTimeout(() => { void esegui().finally(pianifica); }, ogniMs);
    };
    const visibile = () => { if (document.visibilityState === 'visible') void esegui(); };
    pianifica();
    document.addEventListener('visibilitychange', visibile);
    return () => {
      if (tempo !== null) window.clearTimeout(tempo);
      document.removeEventListener('visibilitychange', visibile);
    };
  }, [attivo, ogniMs]);
}
